import * as React from 'react';
import { observer } from 'mobx-react';

// Styles
const s = require('./BusinessPartner.css');

// Component
@observer
export class LeadPricingRequest extends React.Component<{}, {}> {
  constructor(props) {
    super(props);
  }

  public render() {
    // TODO: Show pending pricing requests with date of request
    // clicking should open modal: for sales rep a read only view, for sales manager edit / approve pricing

    // TODO: Below show button "Approved pricing" with date of last approved pricing
    // Clicking by any user shold open modal with all items in table, no search bar, and current approved prices for the lead

    return <div />;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.tsx